let decodeSafe = v => {
	try {
		return decodeURIComponent(v);
	} catch (e) {
		return v;
	}
};

export default function(queryString = typeof location !== 'undefined' ? location.search : '') {
	return (queryString || '').slice(1).split('&').reduce((qs, el) => {
		const [name, ...value] = el.split('=');
		qs[name] = value.length ? decodeSafe(value.join('=')) : true;
		return qs;
	}, {});
}
